export default __webpack_public_path__ + "static/3-0-0-0-8f5930d23ed7c54403cafddce94a1c41.jpg";